module.exports = __webpack_public_path__ + "img/csgomen.e39a3879.jpeg";